import session from '../../auth_api/session'

const URL = process.env.VUE_APP_API_URL
const URLImportFile = URL + 'hemodialysis/api/'

export default {
  namespaced: true,
  state: {
    listPerson: { 'results': [] },
    person: {},
    defaultPerson: {
      id: null,
      surname: '',
      name: '',
      patronymic: '',
      birthday: null,
      snils: ''
    }
  },
  mutations: {
    setListPerson (state, payload) {
      state.listPerson = payload
    },
    setPerson (state, payload) {
      // Vue.set(state.listPerson.results, payload.index, payload.data)
      state.person = payload
      state.person.birthday = state.person.birthday.substr(0, 10)
    },
    setDefaultPerson (state) {
      // Vue.set(state.listPerson.results, payload.index, payload.data)
      state.person = Object.assign({}, state.defaultPerson)
    }
  },
  actions: {
    fetchListPerson ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'hemodialysisFetchListPerson'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let params = {}
        if ((0 + payload.pageId) > 1) {
          params['page'] = payload.pageId
        }
        if (payload.search > '') {
          params['search'] = payload.search
        }
        let _url = URLImportFile + 'person/'
        session.get(_url, { params: params })
          .then(response => {
            commit('setListPerson', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    fetchPerson ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'hemodialysisFetchPerson'
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = URLImportFile + 'person/' + payload.id + '/'
        session.get(_url)
          .then(response => {
            commit('setPerson', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    insertPerson ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'hemodialysisInsertPerson_' + payload.id
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        // TODO: Код не очень
        const data = new FormData()
        data.append('surname', payload.surname)
        data.append('name', payload.name)
        data.append('snils', payload.snils)
        data.append('birthday', payload.birthday + 'T00:00:00')
        if (payload.patronymic) {
          data.append('patronymic', payload.patronymic)
        }
        let _url, method
        if (payload.id === null) {
          _url = URLImportFile + 'person/'
          method = 'post'
        } else {
          _url = URLImportFile + 'person/' + payload.id + '/'
          method = 'put'
        }

        session({ method: method, url: _url, data: data, headers: { 'Content-Type': 'multipart/form-data' } }
        )
          .then(response => {
            commit('setPerson', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    },
    deletePerson ({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        const loaderName = 'hemodialysisDeletePerson_' + payload
        commit('common/clearError', null, { root: true })
        commit('common/pushLoading', loaderName, { root: true })
        let _url = URLImportFile + 'person/' + payload + '/delete/'
        session.get(_url)
          .then(response => {
            commit('setPerson', response.data)
            commit('common/popLoading', loaderName, { root: true })
            resolve()
          })
          .catch(e => {
            dispatch('common/setError', e, { root: true })
            commit('common/popLoading', loaderName, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {
    listPerson (state) {
      return state.listPerson
    },
    person (state) {
      return state.person
    }
  }
}
